import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
const SITE = 'https://comunitatearise.ro';
const GOOGLE_FORM = 'https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform';
const links = [{
  label: 'Acasă',
  href: `${SITE}/acasa`
}, {
  label: 'Oferte R.I.S.E.',
  href: `${SITE}/oferterise`
}, {
  label: 'Sesiune Cadou',
  href: `${SITE}/sesiune1la1`
}, {
  label: 'Contact',
  href: `${SITE}/contact`
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="bg-rise-white text-rise-black sticky top-0 z-50 border-b border-gray-200" data-id="element-289">
      <div className="max-w-rise-content mx-auto px-6 h-20 flex items-center justify-between" data-id="element-290">
        <a href={`${SITE}/acasa`} target="_top" className="font-playfair text-[24px] font-semibold tracking-wider text-rise-black hover:text-rise-gold transition-colors" data-id="element-291">
          R.I.S.E.
        </a>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8 font-dm-sans text-[15px] font-medium" data-id="element-292">
          {links.map(link => <a key={link.label} href={link.href} target="_top" className="hover:text-rise-gold transition-colors" data-id="element-293">
              {link.label}
            </a>)}
          <a href={GOOGLE_FORM} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-2.5 rounded-xl font-dm-sans font-semibold transition-colors" data-id="element-294">
            Rezervă Sesiunea Cadou!
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-rise-black hover:text-rise-gold transition-colors" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-295">
          {isOpen ? <X size={28} data-id="element-296" /> : <Menu size={28} data-id="element-297" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-rise-white border-b border-gray-200 px-6 py-4 flex flex-col gap-4 font-dm-sans text-[16px] absolute w-full shadow-lg" data-id="element-298">
          {links.map(link => <a key={link.label} href={link.href} target="_top" onClick={() => setIsOpen(false)} className="hover:text-rise-gold transition-colors py-2" data-id="element-299">
              {link.label}
            </a>)}
          <a href={GOOGLE_FORM} target="_top" onClick={() => setIsOpen(false)} className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-3 rounded-xl font-dm-sans font-semibold transition-colors text-center mt-2" data-id="element-300">
            Rezervă Sesiunea Cadou!
          </a>
        </div>}
    </nav>;
}